export function adaptBlockToMobile(selector: string) {
  const elementToAdapt = document.querySelector(selector);
  if (elementToAdapt) {
    (elementToAdapt as HTMLElement).style.height = `${window.innerHeight}px`;
  }
}
